import { render, staticRenderFns } from "./UserGroupRoles.vue?vue&type=template&id=0fbd22d5"
import script from "./UserGroupRoles.vue?vue&type=script&lang=ts"
export * from "./UserGroupRoles.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports